function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useStoreActions } from "../../../contexts";
import { useContacts } from "../../../hooks/reactQuery/queries/useContacts";
import { QueryKeys } from "../../../hooks/reactQuery/queryKeys";
import { useQueryState } from "../../../hooks/reactQuery/useQueryState";
export const useArchivedProposals = () => {
  const {
    api
  } = useStoreActions();
  const {
    refresh: refreshContacts
  } = useContacts();
  const {
    data: archivedProposalsWithContact,
    isLoading,
    isBackgroundLoading,
    error,
    refresh
  } = useQueryState({
    queryKey: [QueryKeys.ArchivedProposals],
    queryFn: async () => {
      const [{
        data: contacts
      }, drafts] = await Promise.all([refreshContacts(), api.draft.getArchivedSummaries()]);
      return drafts.map(draft => _objectSpread(_objectSpread({}, draft), {}, {
        contactDetails: contacts === null || contacts === void 0 ? void 0 : contacts.filter(contact => contact.id() === draft.clientContactId).map(contact => ({
          firstName: contact.firstName(),
          lastName: contact.lastName(),
          email: contact.email(),
          companyName: contact.companyName()
        }))[0]
      }));
    },
    keepDataFresh: true
  });
  return {
    drafts: archivedProposalsWithContact,
    isBackgroundLoading,
    isLoading,
    error,
    refresh
  };
};